import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogContent, DialogContentText } from '@mui/material'
import PaymentTermsConditions from 'components/payments/PaymentTermsConditions'
import HHDialogActions from 'components/common/HHDialogActions'
import T from 'T'
import HHDialogTitle from 'components/common/HHDialogTitle'

const TermsNConditionsDialog = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <HHDialogTitle title={T.TERMS_N_CONDITIONS} onClose={onClose} />
      <DialogContent>
        <DialogContentText>
          <PaymentTermsConditions />
        </DialogContentText>
      </DialogContent>
      <HHDialogActions>
        <Button size="small" variant="contained" onClick={onClose}>
          {T.CLOSE}
        </Button>
      </HHDialogActions>
    </Dialog>
  )
}

TermsNConditionsDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

export default TermsNConditionsDialog
